const getFeatureReducer = state => state.feature;

export default {
  activeFeatures: store => getFeatureReducer(store).activeFeatures,
  abTestActiveFeatures: store => getFeatureReducer(store).abTestActiveFeatures,
  activeFeatureFlags: store => getFeatureReducer(store).activeFeatureFlags
};
